import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { initDevTools } from './utils/devUtils.ts';
import { initTracker } from './utils/track.ts';

initDevTools();
initTracker();

createRoot(document.getElementById('root')!).render(<App />);
